let store = null;

export const setStore = (_store) => {
  store = _store;
};

export const getStore = () => store;
